import Phaser from "phaser";

export class TargetRing {
  private graphic: Phaser.GameObjects.Arc;
  private _radius: number;
  private scene: Phaser.Scene;

  // linear movement
  private moveDir: { x: number; y: number } = { x: 0, y: 0 };
  private speed: number = 0;

  constructor(scene: Phaser.Scene, x: number, y: number, radius: number) {
    this.scene = scene;
    this._radius = radius;
    this.graphic = scene.add.circle(x, y, radius);
    this.graphic.setStrokeStyle(3, 0xffffff);
    this.graphic.setFillStyle(0xffffff, 0.05);
    this.graphic.setDepth(10);
  }

  get x(): number {
    return this.graphic.x;
  }

  get y(): number {
    return this.graphic.y;
  }

  get radius(): number {
    return this._radius;
  }

  setLinearMotion(speedPxPerSec: number): void {
    this.speed = speedPxPerSec;
    const angle = Math.random() * Math.PI * 2;
    this.moveDir = { x: Math.cos(angle), y: Math.sin(angle) };
  }

  update(dt: number): void {
    if (this.speed === 0) return;
    const gameW = this.scene.scale.width;
    const gameH = this.scene.scale.height;

    let nx = this.graphic.x + this.moveDir.x * this.speed * dt;
    let ny = this.graphic.y + this.moveDir.y * this.speed * dt;

    const margin = this._radius + 10;
    if (nx < margin || nx > gameW - margin) {
      this.moveDir.x *= -1;
      nx = Phaser.Math.Clamp(nx, margin, gameW - margin);
    }
    if (ny < margin || ny > gameH - margin) {
      this.moveDir.y *= -1;
      ny = Phaser.Math.Clamp(ny, margin, gameH - margin);
    }

    this.graphic.setPosition(nx, ny);
  }

  setPosition(x: number, y: number): void {
    this.graphic.setPosition(x, y);
  }

  setRadius(r: number): void {
    this._radius = r;
    this.graphic.setRadius(r);
  }

  flashSuccess(): void {
    this.scene.tweens.add({
      targets: this.graphic,
      scaleX: 1.3,
      scaleY: 1.3,
      alpha: 0.3,
      duration: 200,
      yoyo: true,
    });
  }

  destroy(): void {
    this.graphic.destroy();
  }
}
